<div class="add-container">
    <div class="d-flex justify-content-between align-items-center">
        <h1 class="add-title m-0 p-0">Vizualizare borderou</h1>
        <button class="action-buttons-side" (click)="closeDialog()">x</button>
    </div>

    <h3 class="m-0">Info - Borderou</h3>
    <mat-divider class="divider-section"></mat-divider>
    <br>

    <div class="row">
        <div class="col-md-12">
            <table class="table table-condensed boxed-section">
                <tbody>
                    <tr class="boxed-header">
                        <td colspan="2" class="text-center"><strong>CREATOR</strong></td>
                    </tr>
                    <tr>
                        <td><strong>#</strong></td>
                        <td>{{ borderouInfo?.creator_user_name }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <div class="row">
        <div class="col-md-6">
            <table class="table table-condensed boxed-section">
                <tbody>
                    <tr class="boxed-header">
                        <td colspan="2" class="text-center"><strong>ORIGINE</strong></td>
                    </tr>
                    <tr>
                        <td><strong>Direcție/Instituție</strong></td>
                        <td>{{ borderouInfo?.origin_directie_name || 'n/a' }}</td>
                    </tr>
                    <tr>
                        <td><strong>Compartiment/Departament</strong></td>
                        <td>{{ borderouInfo?.origin_compartiment_name || 'n/a' }}</td>
                    </tr>
                    <tr>
                        <td><strong>Operator</strong></td>
                        <td>{{ borderouInfo?.origin_user_name || 'n/a' }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="col-md-6">
            <table class="table table-condensed boxed-section">
                <tbody>
                    <tr class="boxed-header">
                        <td colspan="2" class="text-center"><strong>DESTINAȚIE</strong></td>
                    </tr>
                    <tr>
                        <td><strong>Direcție/Instituție</strong></td>
                        <td>{{ borderouInfo?.destination_directie_name || 'n/a' }}</td>
                    </tr>
                    <tr>
                        <td><strong>Compartiment/Departament</strong></td>
                        <td>{{ borderouInfo?.destination_compartiment_name || 'n/a' }}</td>
                    </tr>
                    <tr>
                        <td><strong>Operator</strong></td>
                        <td>{{ borderouInfo?.destination_user_name || 'n/a' }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <h3 class="m-0">Vizualizare Documente - Borderou</h3>
    <mat-divider class="divider-section"></mat-divider>
    <br>

    <table class="table table-condensed">
        <thead>
            <tr>
                <th>Crt.</th>
                <th>Nr. Reg.</th>
                <th>Dată Înregistrare</th>
                <th>Cale Acces/Ieșire</th>
                <th>Proveniență</th>
                <th>Tip Document</th>
                <th>Destinatar</th>
                <th>Nr. Extern</th>
                <th>Term. Rez.</th>
                <th>Documente în original?</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngIf="!borderouRecords.length">
                <td colspan="10" class="text-center py-2">
                    <strong><i>Lipsă înregistrări</i></strong>
                </td>
            </tr>
            <tr *ngFor="let row of borderouRecords; let i = index">
                <td>{{ i + 1 }}</td>
                <td>{{ row.reg_number || 'n/a' }}</td>
                <td>
                    <div>{{ row.created_at ? (row.created_at | date : "dd.MM.yyyy HH:mm" : "ro")
                        : 'n/a' }}</div>
                    <div><i class="fa fa-user"></i> {{ row.origin_user_name || 'n/a' }}</div>
                </td>
                <td>{{ row.category || 'n/a' }}</td>
                <td>{{ row.entity || 'n/a' }}</td>
                <td>{{ row.document_tip_name || 'n/a' }}</td>
                <td>
                    <div><i class="fa fa-book"></i> {{ row.destination_directie_name || 'n/a'}}</div>
                    <div><i class="fa fa-cubes"></i> {{ row.destination_compartiment_name ||'n/a' }}</div>
                    <div><i class="fa fa-user"></i> {{ row.destination_user_name || 'n/a' }}</div>
                </td>
                <td>{{ row.extern_numar || 'n/a' }}</td>
                <td>{{ row.last_day_work || 'n/a' }}</td>
                <td>{{ row.dosar_original === 1 ? 'DA' : 'NU' }}</td>
            </tr>
        </tbody>
    </table>

    <div class="section-spinner position-absolute" *ngIf="isLoading">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>